import { CACHE_KEY } from '@src/utils';
import { apiService } from './ServiceApi';
import { setJWTToken, setJWTExpiry, getJWTToken } from '@src/utils/tokenManager';

const loginService = apiService.injectEndpoints({
  endpoints: (builder) => {
    return {
      getUserDetails: builder.query({

        query: (pData) => {

          return {
            method: 'POST',
            url: 'gpsservice/api/user-acl/getUserAccess',
            body:{
             userId:pData.userId,
             userType:pData.userType,
             userRole:pData.userRole
            },
            params:{},

          };
        },
      }),
      getAuthentication: builder.query({
        async queryFn(token, _queryApi, _extraOptions, fetchWithBQ) {
          const result = await fetchWithBQ({
            method: 'GET',
            url: 'gpsservice/api/user-acl/getAuthorizedUsersFromOIDC',
            params: {
              token,
              isAuth: true,
            },
          });
          const jwtToken = (result.data as any)?.accessToken;
          const expirationTime = (result.data as any)?.expirationTime;
          // Migrated backends return the token only as an HttpOnly cookie, so the body carries just the expiry.
          if (jwtToken) {
            setJWTToken(jwtToken, expirationTime);
          } else if (expirationTime) {
            setJWTExpiry(expirationTime);
          }
          return result;
        },
      }),
      getInternalUserAcl: builder.query({
        query: (userId) => {

          return {
            method: 'POST',
            url: 'gpsservice/api/user-acl/getInternalUserAcl',
            params: {},
            body: JSON.stringify({ userId: userId, }),
            headers: {
              'Content-Type': 'application/json',
            },

          };
        },
      }),

      updateInternalUserAcl: builder.query({
        query: (userData) => {
          return {
            method: 'POST',
            url: 'gpsservice/api/user-acl/updateInternalUserAcl',
            params: {},
            body: userData,
          };
        },
      }),
      removeInternalUserAcl: builder.query({
        query: (userData) => {
          return {
            method: 'POST',
            url: 'gpsservice/api/user-acl/removeInternalUserAcl',
            params: {},
            body: userData,
          };
        },
      }),
      getAuthenticationWelcomeping: builder.query({
        async queryFn(token, _queryApi, _extraOptions, fetchWithBQ) {
          const result = await fetchWithBQ({
            method: 'POST',
            url: 'gpsservice/api/user-acl/getAuthorizedUsersFromOpenToken',
            body: JSON.stringify({ isAuth: true }),
            headers: {
              'Content-Type': 'application/json',
            },
            params: {
              opentoken: token,
            },
          });
          const jwtToken = (result.data as any)?.accessToken;
          const expirationTime = (result.data as any)?.expirationTime;
          // Migrated backends return the token only as an HttpOnly cookie, so the body carries just the expiry.
          if (jwtToken) {
            setJWTToken(jwtToken, expirationTime);
          } else if (expirationTime) {
            setJWTExpiry(expirationTime);
          }
          return result;
        },
      }),
      refreshToken: builder.query({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
          // Still sent so a backend that has not yet moved to the cookie can authenticate the refresh.
          const currentToken = getJWTToken();
          const result = await fetchWithBQ({
            method: 'POST',
            url: 'gpsservice/api/user-acl/refreshToken',
            params: {},
            body: currentToken ? { token: currentToken } : {},
            headers: { 'Content-Type': 'application/json' },
          });
          const expirationTime = (result.data as any)?.expirationTime;
          // Migrated backends return the token only as an HttpOnly cookie, so the body carries just the expiry.
          const legacyToken = (result.data as any)?.token;
          if (legacyToken) {
            setJWTToken(legacyToken, expirationTime);
          } else if (expirationTime) {
            setJWTExpiry(expirationTime);
          }
          return result;
        },
      }),
      getAnnouncement: builder.query({
        query: (params) => {
          return {
            method: 'GET',
            url: '/gpsservice/api/user-acl/getAnnouncement',
            params: {},
            body: {},
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      updateAnnouncement: builder.query({
        query: (annouceData) => {
          return {
            method: 'POST',
            url: 'gpsservice/api/user-acl/updateAnnouncement',
            body: JSON.stringify(annouceData),
            headers: {
              'Content-Type': 'application/json',
            },
            params:{}
          };
        },
      }),
    };
  },
});

export const {
  useGetUserDetailsQuery,
  useLazyRefreshTokenQuery,
  useLazyGetInternalUserAclQuery,
  useLazyUpdateInternalUserAclQuery,
  useLazyGetUserDetailsQuery,
  useLazyGetAuthenticationQuery,
  useLazyRemoveInternalUserAclQuery,
  useLazyGetAuthenticationWelcomepingQuery,
  useLazyGetAnnouncementQuery,
  useLazyUpdateAnnouncementQuery
} = loginService;
